import type { DateValue } from '@internationalized/date';

import type { RangeValue } from '../types';

export function isInvertedDateRange(
  range: RangeValue<DateValue> | null | undefined
): boolean {
  if (!range) return false;
  return range.start.compare(range.end) > 0;
}
